export const MinutesInHour: number = 60
